import React, { useState } from 'react'
import { Control, Controller, FieldValues, RegisterOptions } from 'react-hook-form'

import TextInput from '../TextInput'

import ElementPopper from 'react-element-popper'
import { Calendar, CalendarProps, Value } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import DateObject from 'react-date-object'

import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'

import CloseIcon from '@material-ui/icons/Close'

import { strings } from 'strings'
import useStyles from './styles'

interface Props extends CalendarProps {
  label?: string
  name: string
  defaultValue?: Value | undefined
  onChangeAction?: () => void
  control: Control<FieldValues> | any
  rules?: Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>
  format?: string
  error?: boolean | undefined
  clearIcon?: boolean
  helperText?: React.ReactNode
}
const DateInput = ({
  label = strings.date,
  name,
  defaultValue = null,
  format,
  error,
  helperText,
  rules,
  control,
  calendar = persian,
  locale = persian_fa,
  clearIcon = true,
  ...rest
}: Props) => {
  const classes = useStyles()

  const [showCalendar, setShowCalendar] = useState(false)

  const openCalendar = () => {
    setShowCalendar(true)
  }

  const closeCalendar = () => {
    setShowCalendar(false)
  }

  const rangeFormat = (date: [DateObject, DateObject] | null) => {
    let value = ''
    const from = date?.[0]?.toString() || ''
    const to = date?.[1]?.toString() || ''
    if (from) value = `${strings.from} ${from} `
    if (to) value += `${strings.to} ${to}`
    return value
  }

  return (
    <ClickAwayListener onClickAway={closeCalendar}>
      <div>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          rules={rules}
          render={({ onChange, value }) => {
            return (
              <ElementPopper
                active={showCalendar}
                element={
                  <TextInput
                    label={label}
                    value={
                      value
                        ? rest.range
                          ? rangeFormat(value)
                          : format
                          ? value?.format(format)
                          : value?.toString()
                        : ''
                    }
                    onFocus={openCalendar}
                    focused={showCalendar}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <>
                          {clearIcon && value && (
                            <InputAdornment position="end" style={{ margin: 0 }}>
                              <IconButton
                                onClick={() => onChange(null)}
                                edge="end"
                                style={{ padding: 2 }}
                              >
                                <CloseIcon style={{ color: 'rgba(0,0,0,0.54)' }} />
                              </IconButton>
                            </InputAdornment>
                          )}
                        </>
                      ),
                    }}
                    error={error}
                    helperText={helperText}
                  />
                }
                popper={
                  <Calendar
                    {...rest}
                    value={value}
                    calendar={calendar}
                    locale={locale}
                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                    onChange={(date) => {
                      onChange(date)
                      // setTimeout(() => {
                      //   closeCalendar()
                      // }, 125)
                    }}
                    maxDate={new Date()}
                    className={classes.calendar}
                  >
                    <IconButton
                      onClick={closeCalendar}
                      style={{ position: 'absolute', top: 4, right: 4, padding: 0 }}
                    >
                      <CloseIcon style={{ color: 'rgba(0,0,0,0.54)' }} />
                    </IconButton>
                    {/* <Button
                      onClick={() => {
                        const newDate = rest.range
                          ? value?.length === 1
                            ? [...value, today]
                            : [today]
                          : today
                        onChange(newDate)
                      }}
                      sx={{ width: '90%', marginBottom: '0.5rem' }}
                      variant="contained"
                      size="small"
                      disableElevation
                    >
                      {translate.today}
                    </Button> */}
                  </Calendar>
                }
                zIndex={12}
                containerStyle={{ width: '100%' }}
              />
            )
          }}
        />
      </div>
    </ClickAwayListener>
  )
}

export default DateInput
